import React from "react";

import { makeStyles, createStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";

import { CSSTransition } from "react-transition-group";

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        overlayError: {
            alignContent: "center",
            background: "rgba(255, 255, 255, 0.6)",
            bottom: 0,
            display: "flex",
            flexDirection: "row",
            flexWrap: "wrap",
            left: 0,
            position: "absolute",
            right: 0,
            top: 0,
        },
        errorItem: {
            textAlign: "center",
            width: "100%",
        },
    })
);

export default function OverlayError(props) {
    const classes = useStyles();
    return (
        <CSSTransition
            in={props.error}
            timeout={1000}
            classNames="fade-animation"
            unmountOnExit
            appear
            key="login-loading"
        >
            <div className={classes.overlayError}>
                <Typography
                    className={classes.errorItem}
                    variant="h5"
                    component="h1"
                    gutterBottom
                >
                    Error
                </Typography>
                <Typography
                    className={classes.errorItem}
                    variant="body1"
                    component="p"
                    gutterBottom
                >
                    {props.errorMessage}
                </Typography>
                {props.errorCode ? (
                    <Typography
                        className={classes.errorItem}
                        variant="body2"
                        component="p"
                        gutterBottom
                    >
                        Error code: {props.errorCode}
                    </Typography>
                ) : null}
            </div>
        </CSSTransition>
    );
}
